<template>
  <div class="limiter">
    <div class="container-login">
      <v-container fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="12" md="9" lg="9">
            <v-card class="login" flat style="border-radius: 10px; padding: 0px;">
              <div style="margin: 5px; padding: 15px; text-align: center" v-if="carregamento == 'CARREGANDO'">
                <p>Carregando pedido...</p>
                <v-progress-linear max-width="100px" indeterminate color="blue"></v-progress-linear>
              </div>
              <div style="margin: 0px; padding: 5px" v-if="carregamento == 'CARREGADO'">
                <v-card outlined>
                  <v-card-title>Resumo de presentes</v-card-title>
                  <v-card-text>
                    <v-card v-for="item in pedido.itensPedido" :key="item.produtoId" tile outlined>
                      <v-list-item style="border: 1px #ddd solid">
                        <v-list-item-avatar tile>
                          <v-avatar tile>
                            <v-img :src="item.urlImagem" contain height="100%"></v-img>
                          </v-avatar>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title>{{ item.descricao }}</v-list-item-title>
                          <v-list-item-subtitle>{{ item.detalhes }}</v-list-item-subtitle>
                        </v-list-item-content>

                        <v-list-item-action>
                          <v-list-item-subtitle style="color: #00BFA5; font-weight: bold;">R$ {{ item.preco }}</v-list-item-subtitle>
                        </v-list-item-action>
                      </v-list-item>
                    </v-card>
                    <h3 style="text-align: center; margin-top: 10px">Total: R$ {{ pedido.valor }}</h3>
                  </v-card-text>
                </v-card>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <loading :active.sync="isLoading" :can-cancel="true" color="#00695C" :is-full-page="fullPage"></loading>
    <Snackbar ref=chamaSnackbar />
  </div>
</template>

<script>
  // Import component
  import Loading from 'vue-loading-overlay';
  /* import vueCard from 'vue-card-express'; */
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  import { baseApiUrl, /* modelBoleto */ } from '@/global'
  import Snackbar from '../../componentes/snackbar.vue'
  import {
    mapState
  } from 'vuex'
  import moment from 'moment'
  import axios from 'axios'
  export default {
    components: { Snackbar, Loading },
    name: 'Auth',
    computed: mapState({
      usuarioLogado: state => state.isMenuVisible,
    }),
    data: function () {
      return {
        isLoading: false,
        fullPage: true,
        convidado: {
          codigo: '',
          nome: '',
          whatsapp: '',
          confirmacao: null,
          presenteou: false,
          empresaId: '',
        },
        empresa: {
          nome: '',
          cnpj: '',
          endereco: '',
          telefone: '',
          descricao: '',
          data: '',
          horario: '',
          imagemUrl: '',
          listaPresentes: null
        },
        carregamento: '',
        presentes: [],
        pedido: [],
        dictionary: {
          custom: {
            nomeCartao: {
              required: () => 'Informe o nome'
            },
            numCartao: {
              required: () => 'Informe o número do cartão de crédito',
            },
            cpftitular: {
              required: () => 'Informe o número do cartão de crédito',
            },
            codCartao: {
              required: () => 'Informe o código de segurança'
            },
            expiraCartaoMes: {
              required: () => 'Informe o mês de validade do cartão',
            },
            expiraCartaoAno: {
              required: () => 'Informe o ano de validade do cartão',
            },
            dateOfBirth: {
                required: () => 'Informe a Data de Nascimento' ,
                date_format: () => 'Informe uma data válida (dd/mm/aaaa)'
            },
          }
        }
      }
    },
    
    mounted: function () {
      this.pegaParametrosUrl()
      this.$validator.localize('pt', this.dictionary)
    },

    methods: {
      async carregaEmpresa(idEmpresa) {
        await axios.get(`${baseApiUrl}Empresas/${idEmpresa}?access_token=JFBsEGfdh12CYleCU6GSbyMPwovCHwf07lQfh9G9nX3GOqCIGNnX7FSGvdlu094F`).then(response => {
          if (response.data) {
            this.empresa = response.data
            this.carregamento = 'CARREGADO'
          }
        })
      },

      async pegaParametrosUrl() {
        this.carregamento = 'CARREGANDO'
        this.isLoading = true
        var params = window.location.search.substring(1).split('&');
        if (params[0] != '') {
          var paramArray = {};                    // Criar objeto que vai conter os parametros
          for (var i=0; i<params.length; i++) {   // Passar por todos os parametros
            var param = params[i].split('=');     // Dividir os parametros chave e valor
            paramArray[param[0]] = param[1];      // Adicionar ao objeto criado antes
          }
          if (paramArray['pedido']) {
            this.carregaPedido(paramArray['pedido'])
          }
        }
        this.isLoading = false
      },

      async carregaPedido(id) {
        await axios.get(baseApiUrl + 'Pedidos/' + id).then(response => {
          if (response.data) {
            this.pedido = response.data
            this.carregaEmpresa(this.pedido.empresaId)
            this.carregaConvidado(this.pedido.convidadoId)
          }
        })
      },

      async carregaConvidado(id) {
        await axios.get(baseApiUrl + 'Convidados/' + id).then(response => {
          if (response.data) {
            this.convidado = response.data
          }
        })
      },

      transformaData(data, formato) {
        let date = moment(data).format(formato);
        return date
      },
    }
  }
</script>

<style scoped>
  /* LOGIN */

  .limiter {
    width: 100%;
    margin: 0 auto;
  }

  .container-login {
    width: 100%;
    min-height: 100vh;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    padding: 15px;
    background: linear-gradient(to right, #424242, #616161);
    background-repeat: no-repeat;
    position: relative;
    z-index: 1;
  }

  .texto {
    font-weight: bold;
    color: #00253E;
    font-size: 17px;
  }

  .login {
    min-width: 80%;
    border-radius: 15px;
    background-color: #fff;
    opacity: 0.9;
    padding-top: 15px;
    padding-bottom: 15px;
  }

  .login-title {
    display: block;
    margin-left: auto;
    margin-right: auto;
    text-align: center
  }

  a {
    text-decoration: none
  }
</style>
